---
title: 'Step 4: Configure the Collector'
install_track_title: Installation Guide (Amazon RDS and Amazon Aurora)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import PublicLastStepLogInsightsLink from '../_public_last_step_log_insights_link.mdx'
import SettingEnvVarsDocker from './_04_setting_env_vars_docker.mdx';

## Configuring the collector with Docker

Create your configuration file (e.g. named `pganalyze_collector.env`) with environment variables like this:

<SettingEnvVarsDocker apiKey={props.apiKey} />

**Note:** The pganalyze collector allows for more [optional settings](https://pganalyze.com/docs/collector/settings) (e.g. AWS access keys, multiple database names)

## Handling Amazon Aurora clusters vs instances

In the case of Amazon Aurora, the collector automatically resolves `cluster` endpoints to the underlying writer instance.

```bash
DB_HOST=mydbcluster.cluster-123456789012.us-east-1.rds.amazonaws.com
```

This will only monitor the writer instance. If you also want to monitor a reader instance, you'll need to use the Multiple Instances method above.

```text
CONFIG_CONTENTS="[pganalyze]
api_key = 'your_pga_organization_api_key'
 
[writer_instance]
db_host = mydbcluster.cluster-123456789012.us-east-1.rds.amazonaws.com
...
 
[reader_instance]
db_host = mydbcluster.cluster-ro-123456789012.us-east-1.rds.amazonaws.com
...
"
```

Alternatively, you can run a separate Docker container to monitor a reader instance.
Create a new configuration file (e.g. named `pganalyze_collector.replica.env`) and use the `cluster-ro` endpoint as the `DB_HOST`:

```bash
DB_HOST=mydbcluster.cluster-ro-123456789012.us-east-1.rds.amazonaws.com
```

If you have a cluster with multiple readers, you either need to add each instance
endpoint to the content of `CONFIG_CONTENTS` (e.g. add each sections like `[reader_instance1]`, `[reader_instance2]`),
or run one pganalyze collector Docker container for each instance.

## Test snapshot

Then run the following:

```bash
docker run --env-file pganalyze_collector.env quay.io/pganalyze/collector:stable test
```

<PublicLastStepLogInsightsLink />
